import React from 'react';
import styled from 'styled-components';

import RedirectButton from './RedirectButton';
import { StyledImage, StyledLogo } from './Styles';

import config from '../helpers/config';
import { useRedirect } from '../hooks/useRedirect';
import logo from '../images/logo.png';
import unpublished from '../images/unpublished.svg';
import { useApp } from '../providers/app-provider';

const Container = styled.section`
  text-align: center;
  font-family: Rubik;
  color: #404960;

  h1,
  a {
    color: #6048f3;
  }

  h2 {
    margin: auto 15vw;
    font-size: calc(30px + 0.5vw);
  }

  h3 {
    font-weight: 500;
    font-size: calc(15px + 0.5vw);
  }

  @media only screen and (min-width: 1000px) {
    h2 {
      font-size: calc(15px + 2vw);
      margin: auto;
    }

    h3 {
      font-size: calc(10px + 1vw);
    }
  }

  img {
    display: block;
    margin: auto;
    margin-top: 20px;
  }
`;

const FlowNotAvailable = () => (
  <Container data-cy="409">
    <link
      href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&amp;display=swap"
      rel="stylesheet"
    />
    <StyledLogo src={logo} alt="Upflowy logo" />
    <StyledImage src={unpublished} alt="Flow under construction" />
    <h2>This amazing flow is currently being built with Upflowy.</h2>
    <h3>What is Upflowy you ask?</h3>
    <RedirectButton url="https://upflowy.com" text="Take a peek" />
    <p>
      Are you the owner of this flow? Login to &nbsp;
      <a href={config.appBaseURLs.admin}>
        {config.appBaseURLs.admin.substr(config.appBaseURLs.admin.indexOf('://') + 3)}
      </a>
      &nbsp; and hit publish to make it live.
    </p>
  </Container>
);

const FlowNotAvailableWrapper = () => {
  const { resourceNotAvailableURL } = useApp();
  const handleRedirect = useRedirect();

  if (resourceNotAvailableURL) {
    handleRedirect(resourceNotAvailableURL);
  }

  return <FlowNotAvailable />;
};

export default FlowNotAvailableWrapper;
